import React,{ useEffect, useRef, useState } from 'react';
import Popup from './components/popup';
import MediumPopup from './components/MediumPopup';
import Test from './Test';
import './styles/App.css'
import mesh from './images/mesh.png'
import portrait from './images/test.png'
import keypoints from './images/keypoints.png'
import frame_line from './images/frame.png'
import frame from './images/frame_nolines.png'
import stars from './images/stars_and_lines.png'
import StyledButton from './components/StyledButton';
import {motion} from 'framer-motion'
import FrameContainer from './components/FrameContainer';
import ScrollHandler from './components/ScrollHandler';
import Modal from './components/Modal';
const App = ()=>{
    const [isLoaded,setIsLoaded] = useState(false)
    const [isFadedOut,setIsFadedOut] = useState(false)
    const [stage,setStage] = useState(0)
    const [isImageLoaded,setIsImageLoaded] = useState(false)
    const [ModaConfig,setModalConfig] = useState({
        show:false,
        onClose:()=>onClose()
    })
    const onClose = ()=>{
        setModalConfig(current=>{
            return{
                ...current,
                show:false
            }
        })
    }
   

    useEffect(()=>{
        const onLoad = ()=>{
            setIsLoaded(true)
            console.log('loaded')
        }
        if(document.readyState === 'complete'){
            onLoad()
        }else{
            window.addEventListener('load',onLoad)
            return ()=>window.removeEventListener('load',onLoad)
        }
    },[])

    useEffect(()=>{
        if(window.innerWidth <= 600){
            setModalConfig(current=>{
                return{
                    ...current,
                    show:true
                }
            })
        }
    },[])
 
return(
    <>
    <Modal
    {...ModaConfig}
    />
    {isFadedOut && isLoaded && isImageLoaded && <ScrollHandler setStage={setStage}/>}
    {/*
    isLoaded && isImageLoaded ? 'sectionsContainer' :''
    */}
    {!isFadedOut && <div onTransitionEnd={()=>setIsFadedOut(true)}  className={`${!isLoaded && !isImageLoaded ? 'sectionsContainer_beforeLoad' : 'sectionsContainer_beforeLoad fadeOut'}`}>

        <div className='spinner'>
        <div class="loadingio-spinner-eclipse-vmsqgf2h7wd">
            <div class="ldio-plvnuv4h7d">
            <div>

            </div>
            </div>
            </div>
            <div className='loading-text'>

                <p>
                    Loading resources . . .
                </p>
            </div>
        </div>
    </div>}

    <div id='first-part'  className={`${isLoaded && isImageLoaded ? 'sectionsContainer':'none'}`}>
    



        
        <div className={stage === 1 ? 'fadeOut section' : 'section'}>
    <div className='header'>
    
        <div className='stars_0'>
                    <img src={stars}></img>
                    
                </div>
                <div className='stars_1'>
                    <img src={stars}></img>
                    
                </div>
                
        <div className='flex'>
        <div className='header-infos'>
                
                <div className='info-popups'>
                        <Popup/>
                        
                        <MediumPopup />
                        

                    </div>
                <motion.div initial={{opacity:0,y:"50%"}} animate={{opacity:1,y:"0"}} transition={{ ease: [0.17, 0.55, 0.55, 1], duration: 0.5 }}  className="wrapper">
                {/* transparent transition */}
                <img className='portrait' onLoad={()=>setIsImageLoaded(true)} src={portrait} />
                <div className='frame'>
                <FrameContainer  />
                </div>
                    <div className="scan-bar">
                    
                    </div>
                    <div  className="mesh">
                        <img src={mesh}/>
                    </div>
                    
                    
                </motion.div>
              
        </div>
       
        <div className='buttons'>
           

            <StyledButton type="standard" content="View Resume" />
            <a target='_blank' style={{textDecoration:'none'}} href='mailto:mohamedchibani420@gmail.com'>

            <StyledButton type="secondary" content="Contact Me"/>
            </a>
        </div>

      

        
        {/*
            <div className='state-below'>
                {scanState}
</div>*/}
        </div>
        
        
        
    
    
    <div className='header-svg-container'>

    <svg width="63" height="560" viewBox="0 0 63 560" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M47 57V232.5L58 245" stroke="#0066FF"/>

<path d="M16 57V232.5L5 245" stroke="#0066FF"/>
<circle className='stroked' cx="59" cy="248" r="3" stroke="#0066FF"/>
<circle className='filled' cx="47" cy="52" r="5" fill="#0066FF"/>
<circle className='filled' cx="16" cy="52" r="5" fill="#0066FF"/>
<circle className='stroked' r="3" transform="matrix(-1 0 0 1 3.5 247.5)" stroke="#0066FF"/>

</svg>

</div>
</div>
</div>
    <Test currentStage={stage}/>
    
    </div>
    
    
    </>
)
}
export default App;